import React from 'react';
import { StreamingDialogTreeNodeData } from '@mutiny-pkg/champaign-schemas/src/schemas/flexiblePages/flexiblePagesTreeNode';
import { transformToContainerQueries } from '../utils/transformBreakpointClasses';

type DialogProps = {
  id: string;
  children?: React.ReactNode;
  isEditor?: boolean;
  dialogRef?: React.Ref<HTMLDialogElement>;
} & StreamingDialogTreeNodeData;

// TypeScript declarations for Tailwind Plus Elements custom elements
/* eslint-disable @typescript-eslint/no-namespace */
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'el-dialog': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
      'el-dialog-backdrop': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> & {
        class?: string;
      };
      'el-dialog-panel': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> & {
        class?: string;
        style?: React.CSSProperties;
        ref?: React.Ref<HTMLElement>;
      };
    }
  }
}
/* eslint-enable @typescript-eslint/no-namespace */

export const Dialog = React.forwardRef<HTMLDialogElement, DialogProps>(
  ({ children, className, domTargetId, isEditor, dialogRef }, ref) => {
    const Wrapper = isEditor ? React.Fragment : 'el-dialog';

    return (
      <Wrapper>
        <dialog
          ref={dialogRef}
          id={domTargetId}
          className="inset-0 m-auto p-0 border-0 bg-transparent max-w-fit max-h-[calc(100vh-2rem)] overflow-visible"
        >
          {!isEditor && <el-dialog-backdrop class="fixed inset-0 bg-black/25 backdrop-blur-xs" />}
          <el-dialog-panel
            ref={ref}
            class={transformToContainerQueries(className, { isEditor })}
            style={{ display: 'block' }}
          >
            {children}
          </el-dialog-panel>
        </dialog>
      </Wrapper>
    );
  },
);

Dialog.displayName = 'Dialog';
